import type { Dispatch } from 'redux';
import assign from 'lodash/assign';
import includes from 'lodash/includes';
import first from 'lodash/first';

import constants from 'app/shared/constants/ConstantsBundle';

let setCookie: { parse: (response: unknown) => Array<{ name: string; value: string }> };
if (__SERVER__) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  setCookie = require('set-cookie-parser');
}

type GetState = () => {
  user: {
    serverSideCookies: Record<string, string>;
    serverSideSetCookiesArray: Array<string>;
  };
};

type Cookies = Record<string, string>;

type SsrTraceEntry = unknown;

type Credentials = {
  csrfToken?: string;
};

const RequesterActions = {
  pushxEid(xEid: string) {
    return function (dispatch: Dispatch) {
      dispatch({
        type: constants.PUSH_XEID,
        payload: xEid,
      });
    };
  },
  saveServerSideRequestCookies(cookies: Cookies) {
    return (dispatch: Dispatch) => {
      return dispatch({
        type: constants.SET_SERVER_SIDE_COOKIES,
        payload: cookies,
      });
    };
  },
  saveServerSideResponseCookies(response: unknown) {
    return (dispatch: Dispatch, getState: GetState) => {
      if (__SERVER__) {
        const cookieArray = setCookie.parse(response);
        const state = getState();
        const updatedServerSideCookies = assign({}, state.user.serverSideCookies);

        cookieArray.forEach((cookie) => {
          updatedServerSideCookies[cookie.name] = cookie.value;
        });

        return dispatch({
          type: constants.SET_SERVER_SIDE_COOKIES,
          payload: updatedServerSideCookies,
        });
      }
    };
  },
  saveServerSideSetCookieArray(cookieArray: Array<string>) {
    return (dispatch: Dispatch, getState: GetState) => {
      const state = getState();

      const existingCookiesToAdd = state.user.serverSideSetCookiesArray.filter((oldCookieLine) => {
        let shouldInclude = true;

        cookieArray.forEach((newCookieLine) => {
          const oldCookieName = first(oldCookieLine.split('='));

          if (includes(newCookieLine, `${oldCookieName}=`)) {
            shouldInclude = false;
          }
        });

        return shouldInclude;
      });

      const totalCookies = cookieArray.concat(existingCookiesToAdd);

      return dispatch({
        type: constants.SET_SERVER_SIDE_SET_COOKIE_ARRAY,
        payload: totalCookies,
      });
    };
  },
  addRequestToSsrTrace(entry: SsrTraceEntry) {
    return (dispatch: Dispatch) => {
      return dispatch({
        type: constants.ADD_REQUEST_TO_SSR_TRACE,
        payload: entry,
      });
    };
  },
  updateSessionToken(sessionToken: string | undefined) {
    return (dispatch: Dispatch) => {
      if (sessionToken) {
        return dispatch({
          type: constants.UPDATE_SESSION_TOKEN,
          payload: sessionToken,
        });
      }

      return false;
    };
  },
  updateCsrfToken(creds: Credentials | undefined) {
    return (dispatch: Dispatch) => {
      if (creds && creds.csrfToken) {
        return dispatch({
          type: constants.UPDATE_CSRF_TOKEN,
          payload: creds.csrfToken,
        });
      }

      return false;
    };
  },
};

export default RequesterActions;
